import { Flex, theme, Typography } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
export const Logo = ({ asLink, color, href, imgSize, bgColor, ...others }) => {
  const {
    token: { borderRadius },
  } = theme.useToken();
  const { activeEmpleado } = useSelector((state) => state.auth);
  return asLink ? (
    <Link to={href || "#"} className="logo-link">
      <Flex gap={others.gap || "small"} align="center" {...others}>
        {activeEmpleado?.empresa?.logo?.[0]?.url ? (
          <img
            src={activeEmpleado?.empresa?.logo?.[0]?.url}
            alt="design sparx logo"
            height={imgSize?.h || 45}
          />
        ) : (
          <Typography.Title
            level={5}
            type="secondary"
            style={{
              color,
              margin: 0,
              padding: `4px 8px`,
              backgroundColor: bgColor,
              borderRadius,
            }}
          >
            {activeEmpleado?.empresa?.nombrecomercial}
          </Typography.Title>
        )}
      </Flex>
    </Link>
  ) : (
    <Flex gap={others.gap || "small"} align="center" {...others}>
      <img
        src="/logo-no-background.png"
        alt="design sparx logo"
        height={imgSize?.h || 48}
      />
      <Typography.Title
        level={4}
        type="secondary"
        style={{
          color,
          margin: 0,
          padding: `4px 8px`,
          backgroundColor: bgColor,
          borderRadius,
        }}
      >
        ALEMAN
      </Typography.Title>
    </Flex>
  );
};
